import vehicle from './vehicle';
import items from './items';

const root = {
	vehicle,
	items
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js